import { Table } from 'antd';
import QRCode from 'qrcode.react';
import styled from 'styled-components';

export const WrapperContent = styled.div<{ padding?: string }>`
  width: 860px;
  height: fit-content;

  display: table;
  padding: ${p => p.padding || '24px'};
`;

export const WrapperNote = styled.div<{ isLoading: boolean }>`
  display: flex;
  width: 100%;
  min-height: 57px;
  border: 1px solid ${p => (p.isLoading ? '#f0f0f0' : 'black')};
  border-top: none;
  float: left;
`;

export const WrapperSignature = styled.div<{ isLoading: boolean }>`
  display: flex;
  width: 100%;
  height: 180px;
  border: 1px solid ${p => (p.isLoading ? '#f0f0f0' : 'black')};
  border-top: none;
  border-radius: 0px 0px 0px 0px;
  float: left;
`;

export const CTable = styled(Table)<{ isLoading: boolean }>`
  width: 100%;

  .column-invitation {
    width: 100%;
  }

  .ant-table-container {
    border-top-left-radius: 0px !important;
    border-top-right-radius: 0px !important;
    border-left: 0px solid #9f9f9f !important;
  }

  table {
    border-top: 0px solid #9f9f9f !important;
    border-top-left-radius: 0px !important;
    border-top-right-radius: 0px !important;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #000000 !important;
    border-right: 1px solid #000000 !important;

    &:first-child {
      border-left: 1px solid #000000 !important;
    }
  }

  .ant-table-thead > tr > th {
    border-bottom: 1px solid #000000 !important;
    border-right: 1px solid #000000 !important;
    border-top: 1px solid #000000 !important;
    border-left: 1px solid #ffffff !important;

    font-weight: 600;

    &:first-child {
      border-top-left-radius: 0px !important;
      border-left: 1px solid #000000 !important;
    }

    &:last-child {
      border-top-right-radius: 0px !important;
    }
  }

  .ant-table-cell {
    padding: 4px !important;
  }
`;

export const PageStyle = `
  @media print {
    body {
      -webkit-print-color-adjust: exact;
      -moz-print-color-adjust: exact;
      -ms-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    #signature {
      break-inside: avoid;
      page-break-before: always;
    }

    .column-invitation {
      width: 100%;
    }
  
    .ant-table-container {
      border-top-left-radius: 0px !important;
      border-top-right-radius: 0px !important;
      border-left: 0px solid #9f9f9f !important;
    }
  
    table {
      border-top: 0px solid #9f9f9f !important;
      border-top-left-radius: 0px !important;
      border-top-right-radius: 0px !important;
    }
  
    .ant-table-tbody > tr > td {
      border-bottom: 1px solid #000000 !important;
      border-right: 1px solid #000000 !important;
  
      &:first-child {
        border-left: 1px solid #000000 !important;
      }
    }
  
    .ant-table-thead > tr > th {
      border-bottom: 1px solid #000000 !important;
      border-right: 1px solid #000000 !important;
      border-top: 1px solid #000000 !important;
      border-left: 1px solid #ffffff !important;
  
      font-weight: 600;
  
      &:first-child {
        border-top-left-radius: 0px !important;
        border-left: 1px solid #000000 !important;
      }
  
      &:last-child {
        border-top-right-radius: 0px !important;
      }
    }
  
    .ant-table-tbody {
      tr:nth-child(n + 1) {
        td:nth-child(2n + 3) {
          background-color: #f8f8f8;
        }
      }
    }

    .ant-table-cell {
      padding: 4px !important;
    }

    @page {
      border-top: 1px solid black;
      -webkit-print-color-adjust: exact;
    }
  }
`;

export const CQRCode = styled(QRCode)`
  width: 64px !important;
  height: 64px !important;
`;
